// Single source of truth for editor layout geometry, shared by EditorApp
// inline styles, the canvas fit computation (common_tools.aspectRatio) and
// SCSS chrome. The Visor ignores the stage insets.

export const CANVAS_ZOOM_MIN = 0.4;
export const CANVAS_ZOOM_MAX = 2.5;
export const CANVAS_ZOOM_STEP = 0.1;

// Room reserved around the slide inside the stage; top inset clears the
// floating canvas toolbar, the slide centers in the remaining region.
export const CANVAS_STAGE_INSETS = { top: 40, bottom: 26, left: 18, right: 18 };

export const LEFT_PANEL_WIDTH = {
  scenes: 260,
  narrowRail: 92, // elementsLibrary / library icon rail
  default: 200,
};
export const LEFT_PANEL_OVERLAY_WIDTH = 400;

export const TIMELINE = {
  defaultHeight: 180,
  minHeight: 160,
  maxHeight: 700,
  collapsedHeight: 44,
};

// Canvas bottom padding when the timeline feature is disabled entirely.
export const CANVAS_AREA_BOTTOM_PADDING = 20;

export const RIGHT_RAIL = {
  stripWidth: 56,
  cardRight: 16,
  cardTop: 16,
  panelWidth: 260,
  zoomReserve: 72, // room for the zoom widget when the timeline is hidden
};
